import { platforms } from "@/mocks/chigua";

export default function PlatformSection() {
  return (
    <section id="platforms" className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
              <i className="ri-layout-grid-line" aria-hidden="true"></i>
              吃瓜入口导航
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">各平台热榜 · 一个入口全直达</h2>
            <p className="mt-3 text-sm text-foreground-600 md:text-base">
              不用来回切换 App，吃瓜入口导航把各主流平台的官方热榜入口集中摆好，想看哪家的瓜田直接点过去。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {platforms.map((p) => (
            <a key={p.name} href={p.url} target="_blank" rel="nofollow noopener noreferrer" className="group flex items-center gap-4 rounded-xl border border-background-200/70 bg-background-100/60 p-4 transition-all hover:-translate-y-1 hover:border-secondary-200 hover:shadow-soft">
              <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${p.theme}`}>
                <i className={`${p.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="text-base font-semibold text-foreground-950">{p.name}</h3>
                <p className="mt-0.5 truncate text-xs text-foreground-500">{p.desc}</p>
              </div>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-50 text-foreground-500 ring-1 ring-background-200 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
                <i className="ri-external-link-line text-sm" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}